import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { PermissionModel } from "../../models/permission.model";
import { HelperService } from "../../services/helper.service";
import { ssRoutes } from "../../../suite-search/ss-routes";
import { srRoutes } from "../../../suite-reports/sr-routes";

@Component({
  selector: 'app-sidenav-list',
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.scss']
})
export class SidenavListComponent implements OnInit {

  @Input() depth = 0;
  @Input() item: PermissionModel;
  @Input() module: string;
  @HostBinding('attr.aria-expanded') ariaExpanded: any;
  expanded = false;

  private routes: any;

  constructor(private router: Router, private helpService: HelperService) { }

  ngOnInit(): void {
    this.ariaExpanded = this.expanded;
    this.getRoutes();
  }

  onItemSelected(item: PermissionModel): void {
    if (!item.children || !item.children.length) {
      this.goTo(item.viewKey);
    }

    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

  goTo(key: string): void {
    if (this.routes.length > 0) {
      const item = this.routes.find((i: any) => i.key === key);

      if (item) {
        this.router.navigate([item.route]);
      } else {
        this.helpService.openSnackbar('View does not exist.', 'error', 500);
      }
    } else {
      this.helpService.openSnackbar('View does not exist.', 'error', 500);
    }
  }

  getRoutes(): void {
    switch (this.module) {
      case 'SS':
        this.routes = ssRoutes;
        break;
      case 'SR':
        this.routes = srRoutes;
        break;
      default:
        this.routes = [];
    }
  }

}
